var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-button',{staticClass:"md-simple",attrs:{"data-tour":"change"},nativeOn:{"click":function($event){return _vm.changeMySelectedApp()}}},[_c('md-icon',[_vm._v("edit")]),_vm._v("\n  Change\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }